var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecondFaceOnb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 174,
    viewBox: "0 0 175 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 207",
    filter: "url(#filter0_f_6069_1608)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.8709,
    cy: 87.0187,
    rx: 47.6443,
    ry: 47.5265,
    fill: "#00F370",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 emoji \"face with raised eyebrow\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M87.8714 120.349C71.501 120.349 53.8398 110.105 53.8398 87.6275C53.8398 65.1496 71.501 54.9058 87.8714 54.9058C96.966 54.9058 105.357 57.8911 111.576 63.335C118.324 69.3057 121.903 77.7349 121.903 87.6275C121.903 97.5201 118.324 105.891 111.576 111.861C105.357 117.305 96.9074 120.349 87.8714 120.349Z",
    fill: "url(#paint0_radial_6069_1608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M115.972 68.1758C119.1 73.2099 120.731 79.204 120.731 85.8713C120.731 95.7639 117.152 104.135 110.404 110.105C104.185 115.549 95.7353 118.593 86.6993 118.593C76.1026 118.593 64.9896 114.291 58.4297 105.165C64.7431 115.502 76.619 120.349 87.8728 120.349C96.9088 120.349 105.358 117.305 111.578 111.861C118.325 105.891 121.904 97.52 121.904 87.6273C121.904 80.1698 119.868 73.5435 115.972 68.1758Z",
    fill: "#037C3B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M94.5602 107.003H81.6517C80.355 107.003 79.3047 105.955 79.3047 104.661C79.3047 103.368 80.355 102.32 81.6517 102.32H94.5602C95.8569 102.32 96.9072 103.368 96.9072 104.661C96.9072 105.955 95.8569 107.003 94.5602 107.003Z",
    fill: "#0D4219"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M99.5487 77.7354C101.72 77.7354 103.656 80.2524 103.656 84.467C103.656 88.6816 101.72 91.1987 99.5487 91.1987C97.3777 91.1987 95.4414 88.6816 95.4414 84.467C95.4414 80.2524 97.3777 77.7939 99.5487 77.7354Z",
    fill: "#0D4219"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M66.4555 77.5007C66.6902 77.0324 66.8662 76.6812 67.1009 76.2714C67.3591 75.9085 67.629 75.5573 67.9223 75.2178C68.5912 74.5095 69.3892 73.9358 70.2693 73.5202C71.2023 73.0871 72.2291 72.8822 73.2618 72.9349C74.2358 72.9817 75.198 73.2217 76.0782 73.6373L76.6649 73.93C76.8409 73.9885 76.9583 74.1056 77.1343 74.1641C77.4277 74.2812 77.7798 74.4568 78.0731 74.5739C78.6833 74.8139 79.3112 75.0071 79.9507 75.1592C80.2558 75.2295 80.5727 75.2705 80.8895 75.2763H81.6523C81.8987 75.2412 82.1393 75.1651 82.3564 75.0422C82.6146 74.9192 82.8493 74.7612 83.0605 74.5739L83.1779 74.4568C83.7646 74.0412 84.5743 74.17 84.9968 74.7495C85.3723 75.2705 85.3254 75.9846 84.8794 76.447C84.5391 76.7924 84.1636 77.1085 83.7646 77.3836C83.3304 77.6704 82.8551 77.887 82.3564 78.0275C82.1217 78.0861 81.7697 78.1446 81.535 78.2031C81.312 78.2968 81.0714 78.3378 80.8309 78.3202C80.3791 78.3319 79.9273 78.3143 79.4813 78.2617C78.6188 78.1622 77.7739 77.969 76.9583 77.6763C76.5534 77.5534 76.1603 77.4012 75.7848 77.208C75.421 77.0734 75.069 76.9153 74.7286 76.7397C73.7488 76.3066 72.6398 76.2422 71.6189 76.5641C71.0967 76.769 70.6038 77.0441 70.152 77.3836C69.9173 77.5592 69.6826 77.7934 69.4479 77.969C69.2191 78.168 69.002 78.3846 68.8025 78.6129L68.5678 78.9056C68.0984 79.409 67.3121 79.4324 66.8075 78.9641C66.784 78.9465 66.7664 78.9231 66.7488 78.9056C66.3674 78.5426 66.2501 77.9865 66.4555 77.5007Z",
    fill: "#0D4219"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M106.059 71.7056C105.59 71.0617 105.296 70.4763 104.944 69.9495C104.686 69.4871 104.352 69.0656 103.947 68.7202C103.771 68.6032 103.653 68.4861 103.536 68.4276C103.413 68.3515 103.272 68.3163 103.125 68.3105C102.709 68.2637 102.28 68.3222 101.893 68.4861C101.353 68.6734 100.825 68.8841 100.309 69.13C99.7808 69.4227 99.2527 69.7154 98.6659 70.0666C97.6098 70.769 96.495 71.53 95.3801 72.291C94.7817 72.689 93.9719 72.5309 93.5612 71.9397C93.2092 71.4539 93.262 70.7866 93.6786 70.3593C94.6115 69.2822 95.6559 68.2988 96.7883 67.4325C98.0088 66.4666 99.3759 65.6939 100.837 65.1495C101.746 64.8569 102.709 64.7808 103.653 64.9154C104.193 65.0208 104.709 65.2198 105.179 65.5008C105.631 65.7525 106.03 66.092 106.352 66.4959C106.91 67.1339 107.35 67.8656 107.643 68.6617C107.937 69.3641 108.171 70.008 108.347 70.5349V70.5934C108.594 71.2841 108.23 72.0451 107.532 72.291H107.526C106.963 72.3963 106.393 72.168 106.059 71.7056Z",
    fill: "#0D4219"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M76.1784 80.6265C73.7199 80.6265 71.4844 82.6986 71.4844 86.1406C71.4844 89.5825 73.7199 91.6488 76.1784 91.6488C78.6369 91.6488 80.8724 89.5766 80.8724 86.1406C80.8724 82.7045 78.6369 80.6265 76.1784 80.6265Z",
    fill: "#0D4219"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M75.9479 82.9272C75.1147 82.5292 74.1114 82.8804 73.7065 83.7116C73.3955 84.3614 73.5363 85.1399 74.0585 85.6433C74.8917 86.0413 75.8951 85.6901 76.2999 84.8589C76.6109 84.2092 76.4701 83.4306 75.9479 82.9272Z",
    fill: "#26883C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M99.1113 80.1061C98.2839 80.0534 97.574 80.6798 97.5212 81.4993V81.5871C97.3393 82.3949 97.8497 83.1968 98.6595 83.3783C98.6829 83.3841 98.7064 83.39 98.7299 83.39C99.5631 83.4368 100.273 82.7988 100.32 81.9676C100.32 81.95 100.32 81.9266 100.32 81.909C100.502 81.1012 99.9914 80.2993 99.1817 80.1178C99.1582 80.112 99.1347 80.112 99.1113 80.1061Z",
    fill: "#26883C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 150",
    d: "M31.3748 90.4131V93.487C31.3748 94.7891 30.3192 95.8447 29.0171 95.8447H25.9297",
    stroke: "#93DAB4",
    strokeWidth: 1.57179
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 152",
    d: "M35.4612 90.4131V93.487C35.4612 94.7891 36.5168 95.8447 37.8189 95.8447H40.9062",
    stroke: "#93DAB4",
    strokeWidth: 1.57179
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 151",
    d: "M31.3748 105.351V102.277C31.3748 100.975 30.3192 99.919 29.0171 99.919H25.9297",
    stroke: "#93DAB4",
    strokeWidth: 1.57179
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 153",
    d: "M35.4612 105.351V102.277C35.4612 100.975 36.5168 99.919 37.8189 99.919H40.9062",
    stroke: "#93DAB4",
    strokeWidth: 1.57179
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 154",
    d: "M133.469 46.9609V50.0349C133.469 51.337 132.413 52.3925 131.111 52.3925H128.023",
    stroke: "#93DAB4",
    strokeWidth: 1.57179
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 155",
    d: "M137.555 46.9609V50.0349C137.555 51.337 138.611 52.3925 139.913 52.3925H143",
    stroke: "#93DAB4",
    strokeWidth: 1.57179
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 156",
    d: "M133.469 61.8979V58.824C133.469 57.5219 132.413 56.4664 131.111 56.4664H128.023",
    stroke: "#93DAB4",
    strokeWidth: 1.57179
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 157",
    d: "M137.555 61.8979V58.824C137.555 57.5219 138.611 56.4664 139.913 56.4664H143",
    stroke: "#93DAB4",
    strokeWidth: 1.57179
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6069_1608",
    x: 0.93185,
    y: 0.197475,
    width: 173.878,
    height: 173.642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.6474,
    result: "effect1_foregroundBlur_6069_1608"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6069_1608",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.6359 96.6656) rotate(-131.701) scale(45.0179 45.0303)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.555597,
    stopColor: "#00F370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondFaceOnb);
export default __webpack_public_path__ + "static/media/second-face-onb.77b41ba8dbcea9ba0ba98afe59a84ebc.svg";
export { ForwardRef as ReactComponent };